module.exports = "<div>\n  <gallery id=\"lightbox\" fluid [loadingStrategy]=\"'lazy'\"></gallery>\n</div>"